import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { getPDFPreview, setPDFBytes } from '../../../actions'
import { CircularProgress } from '@mui/material'

export default function ReportPreview({ trfBarcode, location, pdfUrl, setPdfUrl, isRelease }) {
  const dispatch = useDispatch()
  const selectedCategorizedList = useSelector((state: RootState) => state.setCategorizedData)
  const pdfUrlData = useSelector((state: RootState) => state.getPDFBytes)
  const reportData = useSelector((state: RootState) => state.setReportData)
  const draftData = useSelector((state: RootState) => state.setDraftReportData)
  const { pathologist, pathologistId, workflowId, procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const pdfLocationInfoData = useSelector((state: RootState) => state.setURLForReportPDF)
  const trfData = useSelector((state: RootState) => state.addTrfInfo)
  const [pdfFlag, setPdfFlag] = useState(true)
  const { role, user } = useSelector((state: RootState) => state.userLogin)
  const { user_name } = useSelector((state: RootState) => state.appConfig)

  const fillTemplate = async () => {
    if (location !== null) {
      const locationsArray = [] as any
      const locationObject = {} as any
      let parentObject = {} as any
      const validChildren = [] as any
      if (selectedCategorizedList.payload && Object.keys(selectedCategorizedList.payload).length)
        Object.keys(selectedCategorizedList.payload).map((key) => {
          if (selectedCategorizedList.payload[key] && Array.isArray(selectedCategorizedList.payload[key]))
            locationObject[key] = handleCaseDiagnosisComments(selectedCategorizedList.payload[key])
        })
      locationObject.location = location
      if (reportData && reportData.sampleInfo && reportData.sampleInfo.sampleInfoTree) {
        parentObject = reportData.sampleInfo.sampleInfoTree.filter((object) => {
          if (object.location === location) {
            return object
          }
        })[0]
        if (parentObject && parentObject.children && parentObject.children.length) {
          parentObject.children.map((child) => {
            if (!child.inactiveReason) {
              validChildren.push(child)
            }
          })
          parentObject.children = validChildren
          if (validChildren.length) {
            locationObject.slideData = parentObject
            locationObject.procedureCode = parentObject.procedureCode
            locationsArray.push(locationObject)
          }
          if (pdfLocationInfoData && pdfLocationInfoData.payload && locationsArray.length) {
            const pdfLocationInfo = pdfLocationInfoData.payload
            await dispatch(
              getPDFPreview({
                isRelease: false,
                pathologistName: getFullName(),
                pathologistId: getPathologistId(),
                data: reportData,
                reason: getReason(),
                locations: locationsArray,
                pdfLocationInfo: pdfLocationInfo,
                consultLP: draftData.consultedPats ? draftData.consultedPats : [],
                practiceInfo: {
                  state: trfData?.practiceInfo?.PraSt,
                  zipCode: trfData?.practiceInfo?.PraZip,
                  city: trfData?.practiceInfo?.PraCity,
                },
              }),
            )
            setPdfFlag(false)
          }
        }
      }
    } else if (location === null) {
      const locationsArray = [] as any
      if (reportData && reportData.sampleInfo && reportData.sampleInfo.sampleInfoTree) {
        for (let i = 0; i < reportData.sampleInfo.sampleInfoTree.length; i++) {
          const validChildren = [] as any
          const parentObject = reportData.sampleInfo.sampleInfoTree[i]
          if (parentObject && parentObject.children && parentObject.children.length) {
            parentObject.children.map((child) => {
              if (!child.inactiveReason) {
                validChildren.push(child)
              }
            })
            parentObject.children = validChildren
            if (validChildren.length) {
              const locationName = parentObject.location
              const locationObject = {} as any
              if (draftData && draftData.reportBuilder && draftData.reportBuilder[locationName]) {
                const reportOptions = draftData.reportBuilder[locationName]
                if (Object.keys(reportOptions).length) {
                  Object.keys(reportOptions).map((key) => {
                    if (reportOptions[key] && Array.isArray(reportOptions[key])) {
                      const comments = handleCaseDiagnosisComments(reportOptions[key])
                      locationObject[key] = comments
                    }
                  })
                }
              }
              locationObject.location = locationName
              locationObject.slideData = parentObject
              locationObject.procedureCode = parentObject.procedureCode
              locationsArray.push(locationObject)
            }
          }
        }
      }
      if (pdfLocationInfoData && pdfLocationInfoData.payload && locationsArray.length) {
        const pdfLocationInfo = pdfLocationInfoData.payload
        await dispatch(
          getPDFPreview({
            isRelease: isRelease ? isRelease : false,
            pathologistName: getFullName(),
            pathologistId: getPathologistId(),
            data: reportData,
            reason: getReason(),
            locations: locationsArray,
            pdfLocationInfo: pdfLocationInfo,
            consultLP: draftData.consultedPats ? draftData.consultedPats : [],
            practiceInfo: {
              state: trfData?.practiceInfo?.PraSt,
              zipCode: trfData?.practiceInfo?.PraZip,
              city: trfData?.practiceInfo?.PraCity,
            },
          }),
        )
        setPdfFlag(false)
      }
    }
  }

  useEffect(() => {
    if (pdfFlag && pdfUrlData && pdfUrlData.payload && pdfUrlData.payload.length > 0) {
      setPdfUrl(pdfUrlData.payload + '#zoom=100&')
      setPdfFlag(false)
    }
  }, [pdfUrlData, pdfFlag])

  const getFullName = () => {
    if (role === 'NL_Pathologist' && user_name && user_name.length) {
      return user_name[0].first_name + ' ' + user_name[0].last_name
    } else {
      return pathologist.first_name + ' ' + pathologist.last_name
    }
  }

  const getPathologistId = () => {
    if (role === 'NL_Pathologist' && user) {
      return user
    } else {
      return pathologistId
    }
  }

  const handleComments = (comments) => {
    const values = comments.map((item) => {
      return item.comment
    })
    return values
  }

  const handleCaseDiagnosisComments = (commentsList) => {
    const finalDisplayComments = [] as any
    if (commentsList) {
      commentsList.map((comment) => {
        if (comment.displayValue) {
          finalDisplayComments.push({
            reportLabel: comment.reportLabel,
            displayValue: comment.diagnosis
              ? comment.diagnosis
              : comment.comment
              ? comment.comment
              : comment.displayValue,
            callout: comment.callout_required ? comment.callout_required : comment.Callout ? comment.Callout : false,
          })
        } else {
          finalDisplayComments.push({
            reportLabel: comment.reportLabel,
            displayValue: comment.diagnosis ? comment.diagnosis : comment.comment ? comment.comment : comment.label,
            callout: comment.callout_required ? comment.callout_required : comment.Callout ? comment.Callout : false,
          })
        }
      })
    }
    return finalDisplayComments
  }

  const getReason = () => {
    switch (workflowId) {
      case 'CORRECT_ASSIGNED_READY':
        return 'corrected'
      case 'CORRECT_ASSIGNED_INPROGRESS':
        return 'corrected'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS':
        return ''
      case 'AMEND_INITIATED':
        return 'amended'
      case 'AMEND_RESULTED_RESULT_RELEASED':
        return 'amended'
    }
  }

  useEffect(() => {
    if (trfBarcode) {
      dispatch(setPDFBytes({ pdfUrl: '' }))
      fillTemplate()
      return () => {
        console.log('pdf generated')
      }
    }
  }, [trfBarcode, location, isRelease])

  return (
    <>
      {pdfUrl && pdfUrl.length > 0 ? (
        <iframe src={pdfUrl} title="DiagnosisReport" height="100%" width="100%" />
      ) : (
        <CircularProgress sx={{ marginLeft: '50%', marginTop: '40%' }} />
      )}
    </>
  )
}
